import React from "react";

const DashboardUsageChart = ({ stats }) => {
  const monthlyUsage = stats?.monthlyUsage || [];

  // Get current month and year from the first data point or current date
  const currentDate = monthlyUsage.length > 0
    ? new Date(monthlyUsage[0].date)
    : new Date();
  const currentMonth = currentDate.toLocaleString('en-US', { month: 'long' });
  const currentYear = currentDate.getFullYear();

  // Group data by week ranges for better visualization
  const groupDataByWeek = (data) => {
    const weeks = [
      { range: "1-7", days: [] },
      { range: "8-14", days: [] },
      { range: "15-21", days: [] },
      { range: "22-28", days: [] },
      { range: "29+", days: [] }
    ];

    data.forEach(day => {
      const date = new Date(day.date);
      const dayOfMonth = date.getDate();

      if (dayOfMonth <= 7) weeks[0].days.push(day);
      else if (dayOfMonth <= 14) weeks[1].days.push(day);
      else if (dayOfMonth <= 21) weeks[2].days.push(day);
      else if (dayOfMonth <= 28) weeks[3].days.push(day);
      else weeks[4].days.push(day);
    });

    return weeks.map(week => ({
      range: week.range,
      totalBookings: week.days.reduce((sum, day) => sum + day.bookings, 0),
      dayCount: week.days.length
    }));
  };

  const weeklyData = groupDataByWeek(monthlyUsage);
  const maxBookings = Math.max(...weeklyData.map(week => week.totalBookings), 1);

  return (
    <div
      className="p-4 rounded-4 bg-white h-100"
      style={{ border: "2px solid #eec0fc" }}
    >
      <div className="lato-bold-24 text-center mb-3">
        {currentMonth.toUpperCase()} USAGE:
      </div>

      {monthlyUsage.length > 0 ? (
        <>
          {/* SVG Chart */}
          <svg width="100%" height="180" viewBox="0 0 400 180">
            {/* Grid lines */}
            {[0, 25, 50, 75, 100].map((percent, index) => (
              <line
                key={index}
                x1="0"
                y1={150 - (percent * 120 / 100)}
                x2="400"
                y2={150 - (percent * 120 / 100)}
                stroke="#f0f0f0"
                strokeWidth="1"
              />
            ))}

            {/* Chart line */}
            <polyline
              fill="none"
              stroke="#a685e2"
              strokeWidth="3"
              points={weeklyData.map((week, index) => {
                const x = 50 + (index * 70);
                const y = 150 - ((week.totalBookings / maxBookings) * 120);
                return `${x},${y}`;
              }).join(' ')}
            />

            {/* Data points */}
            {weeklyData.map((week, index) => {
              const x = 50 + (index * 70);
              const y = 150 - ((week.totalBookings / maxBookings) * 120);
              return (
                <g key={index}>
                  <circle cx={x} cy={y} r="5" fill="#a685e2" />
                  <text
                    x={x}
                    y={y - 10}
                    fontSize="12"
                    textAnchor="middle"
                    fill="#a685e2"
                    fontWeight="bold"
                  >
                    {week.totalBookings}
                  </text>
                </g>
              );
            })}

            {/* Week labels */}
            {weeklyData.map((week, index) => {
              const x = 50 + (index * 70);
              return (
                <text
                  key={index}
                  x={x}
                  y="170"
                  fontSize="12"
                  textAnchor="middle"
                  fill="#666"
                >
                  {week.range}
                </text>
              );
            })}

            {/* Axis labels */}
            <text x="200" y="190" fontSize="12" textAnchor="middle" fill="#666">
              Weeks of {currentMonth}
            </text>
            <text x="10" y="75" fontSize="12" textAnchor="middle" fill="#666" transform="rotate(-90 10,75)">
              Bookings
            </text>
          </svg>

          {/* Summary Stats */}
          <div className="row text-center mt-3">
            <div className="col-6">
              <div className="lato-bold-14" style={{ color: "#666" }}>Total Days</div>
              <div className="bebas-bold-16" style={{ color: "#a685e2" }}>
                {monthlyUsage.length}
              </div>
            </div>
            <div className="col-6">
              <div className="lato-bold-14" style={{ color: "#666" }}>Total Bookings</div>
              <div className="bebas-bold-16" style={{ color: "#a685e2" }}>
                {monthlyUsage.reduce((sum, day) => sum + day.bookings, 0)}
              </div>
            </div>
          </div>
        </>
      ) : (
        <div className="d-flex align-items-center justify-content-center h-75">
          <div className="text-center">
            <div className="lato-medium-16 mb-2" style={{ color: "#666" }}>
              No usage data available
            </div>
            <div className="lato-medium-14" style={{ color: "#999" }}>
              No bookings for {currentMonth} yet
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default DashboardUsageChart;